import { styled } from "@mui/system";
import { colors } from "../../../utils";


export const SwitchContainer = styled("div")(({ disabled }) => ({
  height: 30,
  minWidth: 90,
  display: "flex",
  borderRadius: 100,
  gap: 4,
  backgroundColor: colors.background,
  opacity: disabled ? 0.5 : 1,
  pointerEvents: disabled ? "none" : "auto",
  marginLeft:10
}));

export const SwitchButton = styled("div")(({ selected, disabled }) => ({
  width: selected ? 55 : 28,
  borderRadius: 100,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor:
    disabled && selected
      ? colors.lightBorder
      : selected
      ? colors.PrimaryPurple500
      : "transparent",
  cursor: disabled ? "not-allowed" : "pointer",
  padding: selected ? 4 : 0,
}));

export const SwitchText = styled("span")(({ disabled }) => ({
  fontSize: 12,
  color: disabled ? colors.lightGrey : "white",
  paddingLeft: 4,
}));

export const EmptyWheelsContainer = styled("div")(({ height = "38" }) => ({
  background: `linear-gradient(45deg, #F7FED5, #CCFEFF, #FDCFFE, #F5EEDE)`,
  height: `${height}vh`,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  gap:20
}));

export const CardContainer = styled("div")({
  height: "32vh",
  padding: 10,
  borderRadius: 8,
  border: `1px solid ${colors.lightBorder}`,
  cursor: "pointer",
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  boxSizing: "border-box",
});

export const CardHeaderContainer = styled("div")({
  flexShrink: 0,
  maxHeight: "24%",
  display: "flex",
  justifyContent: "space-between",
  textOverflow: "ellipsis",
});

/** Absolute wallpaper layer (hue ::after must not sit on the same stacking context as the wheel). */
export const CardWallpaperBackground = styled("div")(
  ({ bg, wallpaperHueColor, wallpaperHuePercentage }) => {
    let background = "#F6F7F9";
    const isImageUrl = (value) => /^(http|https|data):/.test(value);

    if (isImageUrl(bg)) {
      background = `url(${bg}) center/cover no-repeat`;
    } else if (bg) {
      background = bg;
    }

    return {
      position: "absolute",
      inset: 0,
      borderRadius: 4,
      zIndex: 0,
      background,
      "&::after": {
        content: '""',
        position: "absolute",
        inset: 0,
        backgroundColor: wallpaperHueColor ?? "#ffffff",
        opacity: ((wallpaperHuePercentage ?? 0) / 100),
        mixBlendMode: "multiply",
        pointerEvents: "none",
        borderRadius: 4,
      },
    };
  }
);

export const CardImageContainer = styled("div")({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: 4,
  flexGrow: 1,
  maxHeight: "19vh",
  overflow: "hidden",
  position: "relative",
});

export const TabsWrapper = styled("div")({
  position: "sticky",
  top: 0,
  zIndex: 1000,
  backgroundColor: "#FFFFFF",
});

export const GradientContainer = styled('div')({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: '100%',
  height: '100%',
  background: `
    conic-gradient(
      from 180deg at 50% 50%, 
      #F5EEDE -41.73deg, 
      #CCFEFF 37.8deg, 
      #F7FED5 140.4deg, 
      #FDCFFE 216deg, 
      #F5EEDE 318.27deg, 
      #CCFEFF 397.8deg
    ),
    linear-gradient(
      0deg, 
      rgba(255, 255, 255, 0.5), 
      rgba(255, 255, 255, 0.5)
    )
  `,
  backgroundBlendMode: 'overlay',
});

export const NoDataContainer = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "382px",
  flexDirection: "column",
  backgroundColor: "#fff",
  padding: "24px",
  gap: "24px",
  borderRadius: "8px",
  boxShadow: "0px 0px 9.3px 0px #3B3B3B1C"
});

export const IconContainer = styled("div")({
  position: "relative",
});

export const TextContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "16px",
});

export const StyledText = styled("span")({
  fontSize: "16px",
  fontWeight: 700,
  color: "#123051",
  lineHeight: "20px",
  textAlign: "center",
  fontFamily: "DM Sans",
});